module.exports = __webpack_public_path__ + "img/ico-saida.0d6e4851.png";